import { CSSObject } from "styled-components";
import { vfxTheme } from "../common/VFX-UI/Theme/theme";

interface DashboardStyles {
    sectionTitle: CSSObject;
    sectionSubtitle: CSSObject;

    tileTitle: CSSObject;
    titleSubtitle: CSSObject;
    tileCaret: CSSObject;
}

export const useDashboardStyles = (): DashboardStyles => {
    return {
        sectionTitle: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.5em",
            textTransform: "none"
        },
        sectionSubtitle: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1em"
        },

        tileTitle: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.5em",
            textTransform: "none",
            marginBottom:0
        },
        titleSubtitle: {
            fontFamily: vfxTheme.typography.fontFamily,
            color: vfxTheme.palette.text.secondary,
            fontSize: ".85em"
        },
        tileCaret: {
            color: vfxTheme.palette.text.secondary,
            fontSize: "1.5em",
        },
    };
};
